// extracted by mini-css-extract-plugin
module.exports = {"prices":"Prices_prices__6kN70","pricesFull":"Prices_pricesFull__Udygk","final":"Prices_final__h4V66","discounted":"Prices_discounted__a_y_4","standard":"Prices_standard__G86_V"};